module.exports = __webpack_public_path__ + "static/media/wifi.277a5bee.png";